import {
  MilestoneDot,
  MilestoneIndicator,
  MilestoneLabel,
  MilestoneLine,
  MilestoneTrack
} from './GanttChart.styles'

export type GanttMilestoneItem = {
  label: string
  left: number
  renderKey: string
}

type GanttMilestonesProps = {
  milestones: GanttMilestoneItem[]
  timelineWidth: number
}

const GanttMilestones = ({
  milestones,
  timelineWidth
}: GanttMilestonesProps) => {
  if (milestones.length === 0) return null

  return (
    <MilestoneTrack $width={timelineWidth}>
      {milestones.map((milestone, index) => (
        <div key={milestone.renderKey}>
          <MilestoneLine
            $left={milestone.left}
            data-testid={`gantt-milestone-footer-line-${index}`}
          />
          <MilestoneDot
            $left={milestone.left}
            data-testid={`gantt-milestone-dot-${index}`}
          />
          <MilestoneIndicator
            $left={milestone.left}
            data-testid={`gantt-milestone-indicator-${index}`}
          >
            <MilestoneLabel>{milestone.label}</MilestoneLabel>
          </MilestoneIndicator>
        </div>
      ))}
    </MilestoneTrack>
  )
}

export default GanttMilestones
